import { useEffect } from 'react';

import { useBackendStatusContext } from '../context/backendStatus/backendStatusContext';
import {
  SET_BACKEND_VERSION,
  SET_BACKEND_AVAILABLE,
  SET_BACKEND_UNAVAILABLE,
  SET_BACKEND_STATUS_LOADING,
  SET_BACKEND_STATUS_SUCCESS,
  SET_BACKEND_STATUS_ERROR,
  SET_BACKEND_STATUS_REBOOTING,
  SET_UPDATING,
} from '../context/backendStatus/backendStatusActions';
import { usePollingManager } from '../context/PollingManagerContext';
import { useAppWorkflowContext } from '../context/AppWorkflowContext';
import { TestWorkflowAction } from '../constants/testWorkflowState';

export default function useInitializeBackendStatus(shouldRun) {
  const { dispatch } = useBackendStatusContext();
  const { dispatchWorkflow } = useAppWorkflowContext();
  const { backendStatus: polledBackendStatus } = usePollingManager();

  useEffect(() => {
    if (!shouldRun) return;

    const init = async () => {
      const isRebooting = localStorage.getItem('sonda.backend.rebooting') === 'true';

      if (isRebooting) {
        dispatch({ type: SET_BACKEND_STATUS_REBOOTING });
        return;
      }

      if (!polledBackendStatus) return;

      dispatch({ type: SET_BACKEND_STATUS_LOADING });

      try {
        const backendVersion = polledBackendStatus;
        dispatch({
          type: backendVersion.isAvailable ? SET_BACKEND_AVAILABLE : SET_BACKEND_UNAVAILABLE,
        });

        if (backendVersion.version) {
          dispatch({ type: SET_BACKEND_VERSION, payload: { version: backendVersion.version } });
        }
        if (backendVersion.version === 'Not able to read version.') {
          dispatch({ type: SET_UPDATING });
          localStorage.setItem('showUpdateInProgressModal', 'true');
          dispatchWorkflow({ type: TestWorkflowAction.ENTER_BACKEND_UPDATING });
        } else if (
          backendVersion.isAvailable &&
          !backendVersion.isUpdating &&
          backendVersion.version &&
          backendVersion.version !== '' &&
          backendVersion.version !== 'Not able to read version.'
        ) {
          localStorage.removeItem('showUpdateInProgressModal');
        }

        dispatch({ type: SET_BACKEND_STATUS_SUCCESS });
      } catch (err) {
        dispatch({ type: SET_BACKEND_UNAVAILABLE });
        dispatch({ type: SET_BACKEND_STATUS_ERROR });
        const isUpdateInProgress = localStorage.getItem('showUpdateInProgressModal') === 'true';
        if (isUpdateInProgress) {
          dispatch({ type: SET_UPDATING });
        }
      }
    };

    init();
  }, [shouldRun, dispatch, polledBackendStatus]);
}
